import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { mainDomainModule } from "../modules";
import { publicRoutePath, routeElement } from "../routes/moduleRoutes";

/**
 * Entry of the main domain (site.html, docs/adr/0016): only the public pages of the module that
 * owns the domain, mounted at the root instead of /p/<id>/. No session, no AppShell, no suite styles.
 */
const container = document.getElementById("root");
if (!container) throw new Error("Missing #root element");

const routes = mainDomainModule?.publicRoutes ?? [];

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          {routes.map((route) => {
            const path = publicRoutePath("/", route);
            return <Route key={path} path={path} element={routeElement(route)} />;
          })}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </StrictMode>,
);

function NotFound(): React.JSX.Element {
  return (
    <main style={{ fontFamily: "system-ui, sans-serif", padding: "64px 24px", textAlign: "center", color: "#04214c" }}>
      <h1 style={{ fontSize: 28 }}>Página no encontrada</h1>
      <p>
        <a href="/">Volver al inicio</a>
      </p>
    </main>
  );
}
